<script setup>
import { VueLenis } from "lenis/vue";
</script>

<template>
    <VueLenis root :options="{ duration: 2 }">
        <router-view v-slot="{ Component, route }">
            <component :is="Component" :key="route.path" />
        </router-view>
    </VueLenis>
</template>
